// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("components/src/assets/font/Vinila-Rg-Cd.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("components/src/assets/font/Vinila-Bd-Cd.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("components/src/assets/font/Vinila-Bk-Cd.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("components/src/assets/font/Vinila-Th-Cd.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("components/src/assets/font/Vinila-Lt-Cd.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("components/src/assets/font/Aeonik-Regular.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("components/src/assets/font/Aeonik-Bold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("components/src/assets/font/Inter-Italic.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("components/src/assets/font/BrinnanThin.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("components/src/assets/font/BrinnanThinOblique.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("components/src/assets/font/Poppins-Regular.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("components/src/assets/font/Poppins-SemiBold.otf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
  /* font-family: 'Vinila', sans-serif; */
}

html,
body {
  /* height: 100%; */
  margin: 0;
  background-color: #f8f8f8;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: 'VinilaBold';
}

a {
  text-decoration: none !important;
}

img {
  display: block;
  max-width: 100%;
  width: 100%;
}

@font-face {
  font-family: 'Vinila';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

@font-face {
  font-family: 'VinilaBold';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

@font-face {
  font-family: 'VinilaBlack';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

@font-face {
  font-family: 'VinilaThin';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}

@font-face {
  font-family: 'VinilaLight';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}

@font-face {
  font-family: 'Aeonik';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}

@font-face {
  font-family: 'AeonikBold';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}

@font-face {
  font-family: 'InterItalic';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}

@font-face {
  font-family: 'BrinnanThin';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}

@font-face {
  font-family: 'BrinnanThinOblique';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
}
@font-face {
  font-family: 'PoppinsRegular';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
}

@font-face {
  font-family: 'PoppinsSemiBold';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
}

.MuiCircularProgress-colorPrimary {
  color: #000 !important;
}

.MuiAlert-message {
  font-size: 24px !important;
}

.MuiAlert-icon {
  font-size: 36px !important;
}

.MuiAlert-action .MuiSvgIcon-root {
  font-size: 2rem !important;
}`, "",{"version":3,"sources":["webpack://./src/global/GlobalStyles.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,SAAS;EACT,sBAAsB;EACtB,uCAAuC;AACzC;;AAEA;;EAEE,kBAAkB;EAClB,SAAS;EACT,yBAAyB;AAC3B;;AAEA;;;;;;EAME,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,4CAAuD;AACzD;;AAEA;EACE,yBAAyB;EACzB,4CAAuD;AACzD;;AAEA;EACE,0BAA0B;EAC1B,4CAAuD;AACzD;;AAEA;EACE,yBAAyB;EACzB,4CAAuD;AACzD;;AAEA;EACE,0BAA0B;EAC1B,4CAAuD;AACzD;;AAEA;EACE,qBAAqB;EACrB,4CAAyD;AAC3D;;AAEA;EACE,yBAAyB;EACzB,4CAAsD;AACxD;;AAEA;EACE,0BAA0B;EAC1B,4CAAuD;AACzD;;AAEA;EACE,0BAA0B;EAC1B,4CAAsD;AACxD;;AAEA;EACE,iCAAiC;EACjC,4CAA6D;AAC/D;AACA;EACE,6BAA6B;EAC7B,6CAA0D;AAC5D;;AAEA;EACE,8BAA8B;EAC9B,6CAA2D;AAC7D;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B","sourcesContent":["* {\n  padding: 0;\n  margin: 0;\n  box-sizing: border-box;\n  /* font-family: 'Vinila', sans-serif; */\n}\n\nhtml,\nbody {\n  /* height: 100%; */\n  margin: 0;\n  background-color: #f8f8f8;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  font-family: 'VinilaBold';\n}\n\na {\n  text-decoration: none !important;\n}\n\nimg {\n  display: block;\n  max-width: 100%;\n  width: 100%;\n}\n\n@font-face {\n  font-family: 'Vinila';\n  src: url('components/src/assets/font/Vinila-Rg-Cd.otf');\n}\n\n@font-face {\n  font-family: 'VinilaBold';\n  src: url('components/src/assets/font/Vinila-Bd-Cd.otf');\n}\n\n@font-face {\n  font-family: 'VinilaBlack';\n  src: url('components/src/assets/font/Vinila-Bk-Cd.otf');\n}\n\n@font-face {\n  font-family: 'VinilaThin';\n  src: url('components/src/assets/font/Vinila-Th-Cd.otf');\n}\n\n@font-face {\n  font-family: 'VinilaLight';\n  src: url('components/src/assets/font/Vinila-Lt-Cd.otf');\n}\n\n@font-face {\n  font-family: 'Aeonik';\n  src: url('components/src/assets/font/Aeonik-Regular.otf');\n}\n\n@font-face {\n  font-family: 'AeonikBold';\n  src: url('components/src/assets/font/Aeonik-Bold.otf');\n}\n\n@font-face {\n  font-family: 'InterItalic';\n  src: url('components/src/assets/font/Inter-Italic.otf');\n}\n\n@font-face {\n  font-family: 'BrinnanThin';\n  src: url('components/src/assets/font/BrinnanThin.otf');\n}\n\n@font-face {\n  font-family: 'BrinnanThinOblique';\n  src: url('components/src/assets/font/BrinnanThinOblique.otf');\n}\n@font-face {\n  font-family: 'PoppinsRegular';\n  src: url('components/src/assets/font/Poppins-Regular.otf');\n}\n\n@font-face {\n  font-family: 'PoppinsSemiBold';\n  src: url('components/src/assets/font/Poppins-SemiBold.otf');\n}\n\n.MuiCircularProgress-colorPrimary {\n  color: #000 !important;\n}\n\n.MuiAlert-message {\n  font-size: 24px !important;\n}\n\n.MuiAlert-icon {\n  font-size: 36px !important;\n}\n\n.MuiAlert-action .MuiSvgIcon-root {\n  font-size: 2rem !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
